import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./pv-project-cycle.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./pv-project-cycle.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { throwError } from "rxjs";
import { AppControllerService } from "../../../../app-controller.service";
import { SaShortDatePipe } from "../../../../shared/pipes/sa-short-date/sa-short-date.pipe";
import { AlertType } from "../../../../shared/models/alert";
import { PopUpComponent } from "../../../../shared/components/pop-up/pop-up.component";
import { catchError, map } from "rxjs/operators";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { PvprojectCycleConfigHeadingLookup, PvprojectCycleConstants, PvprojectCycleHeadingEnum } from "./pv-project-cycle.constants";
import { AddprojectCycleComponent } from "./add-project-cycle/add-project-cycle.component";
import { EditprojectCycleComponent } from "./edit-project-cycle/edit-project-cycle.component";
import { SettingsService } from "../../settings.service";
import { FileUtils } from "src/app/shared/utils/file-utils";
let PvprojectCycleComponent = class PvprojectCycleComponent {
    modalService;
    appController;
    settingsService;
    saShortDatePipe;
    changeDetectorRef;
    deleteLabel = SharedConstants.DELETE_LABEL;
    editLabel = SharedConstants.EDIT_LABEL;
    addLabel = SharedConstants.ADD_LABEL;
    noItemSelected = SharedConstants.NO_ITEM_SELECTED;
    moreThanOneSelected = SharedConstants.MORE_THAN_ONE_SELECTED;
    removeTitle = PvprojectCycleConstants.REMOVE_TITLE;
    removeMessage = PvprojectCycleConstants.REMOVE_MESSAGE;
    componentName = PvprojectCycleConstants.COMPONENT_NAME;
    deleteClosedError = PvprojectCycleConstants.DELETE_CLOSED_ERROR;
    moduleId;
    dataSource;
    tableItems;
    selection;
    tableMapper;
    documentsLabel = PvprojectCycleHeadingEnum.Documents;
    deletedprojectCycles = [];
    deleteMultipleprojectCycleSubscription;
    constructor(modalService, appController, settingsService, saShortDatePipe, changeDetectorRef) {
        this.modalService = modalService;
        this.appController = appController;
        this.settingsService = settingsService;
        this.saShortDatePipe = saShortDatePipe;
        this.changeDetectorRef = changeDetectorRef;
        this.moduleId = +this.appController.selectedModuleID;
        this.initializeColumnToObjectMapping();
    }
    ngOnInit() {
        this.getprojectCycles();
    }
    arrayReturned(array) {
        this.selection = array;
    }
    onBtnAddClicked() {
        const dialogRef = this.modalService.open(AddprojectCycleComponent, PvprojectCycleConstants.MODAL_OPTIONS);
        dialogRef.result.then((refresh) => {
            if (refresh) {
                this.changeDetectorRef.markForCheck();
                this.getprojectCycles();
            }
        }).catch(() => {
        });
    }
    onBtnEditClicked() {
        if (this.selection.length === 0) {
            this.appController.showMessage(this.noItemSelected, AlertType.Warning);
            return;
        }
        if (this.selection.length > 1) {
            this.appController.showMessage(this.moreThanOneSelected, AlertType.Warning);
            return;
        }
        const projectCycleToEdit = this.selection[0];
        const dialogRef = this.modalService.open(EditprojectCycleComponent, PvprojectCycleConstants.MODAL_OPTIONS);
        dialogRef.componentInstance.projectCycleToEdit = projectCycleToEdit;
        dialogRef.result.then((refresh) => {
            if (refresh) {
                this.changeDetectorRef.markForCheck();
                this.getprojectCycles();
            }
        });
    }
    onBtnRemoveClicked() {
        if (this.selection.length <= 0) {
            this.appController.showMessage(this.noItemSelected, AlertType.Warning);
        }
        else if (!this.deleteAllowed()) {
            this.appController.showMessage(this.deleteClosedError, AlertType.Warning);
        }
        else {
            const deletedprojectCycles = this.selection;
            const dialogRef = this.modalService.open(PopUpComponent, PvprojectCycleConstants.MODAL_OPTIONS);
            dialogRef.componentInstance.title = this.removeTitle;
            dialogRef.componentInstance.contentMessage = this.removeMessage;
            dialogRef.componentInstance.data = deletedprojectCycles;
            dialogRef.result.then((deleteprojectCycle) => {
                if (deleteprojectCycle) {
                    this.changeDetectorRef.markForCheck();
                    this.removeprojectCycles(deleteprojectCycle);
                }
            }).catch(() => {
            });
        }
    }
    getprojectCycles() {
        this.tableItems = [];
        this.selection = [];
        this.deletedprojectCycles = [];
        this.dataSource = this.settingsService.getprojectCyclesToRefactor(this.moduleId, this.tableItems).pipe(catchError((error) => {
            this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            return throwError(error);
        }));
        this.dataSource = this.settingsService.getprojectCyclesToRefactor(this.moduleId, this.tableItems)
            .pipe(map(projectCycles => {
            const values = [];
            projectCycles.forEach(projectCycle => {
                const links = new Array;
                if (projectCycle.pvProjectCycleAttachmentLinks && projectCycle.pvProjectCycleAttachmentLinks.length > 0) {
                    const att = new Array;
                    projectCycle.pvProjectCycleAttachmentLinks.forEach(a => {
                        att.push(a.attachment);
                    });
                    att.forEach(at => links.push(this.getAttachmentLinkColumn(at)));
                }
                const vRun = {
                    id: projectCycle.id,
                    deleted: projectCycle.deleted,
                    moduleId: projectCycle.moduleId,
                    fromDate: this.saShortDatePipe.transform(projectCycle.fromDate),
                    toDate: this.saShortDatePipe.transform(projectCycle.toDate),
                    description: projectCycle.description,
                    name: projectCycle.name,
                    completed: projectCycle.completed,
                    completedString: projectCycle.completed ? "Yes" : "No",
                    createdUserId: projectCycle.createdUserId,
                    createdDate: this.saShortDatePipe.transform(projectCycle.createdDate),
                    lastEditedUserId: projectCycle.lastEditedUserId,
                    lastEditedDate: this.saShortDatePipe.transform(projectCycle.lastEditedDate),
                    parameters: projectCycle.parameters,
                    links
                };
                values.push(vRun);
            });
            this.changeDetectorRef.markForCheck();
            return values;
        }), catchError(error => {
            this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    deleteRequest() {
        if (this.deletedprojectCycles.length > 0) {
            const deleteIds = [];
            this.deletedprojectCycles.forEach((run) => {
                deleteIds.push(run.id);
            });
            const params = {
                ids: deleteIds
            };
            this.deleteMultipleprojectCycleSubscription = this.settingsService.deleteMultipleprojectCycle(params).subscribe({
                next: (idsOfDeletedRuns) => {
                    this.deleteRequestComplete(idsOfDeletedRuns);
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Delete);
                }
            });
        }
    }
    deleteRequestComplete(response) {
        if (response) {
            this.appController.showMessage(SharedConstants.REMOVE_SUCCESS, AlertType.Success);
        }
        else {
            this.appController.showMessage(SharedConstants.REMOVE_FAILED, AlertType.Error);
        }
        this.changeDetectorRef.markForCheck();
        this.getprojectCycles();
    }
    removeprojectCycles(deleteRuns) {
        this.deletedprojectCycles = deleteRuns;
        this.selection = [];
        this.deleteRequest();
    }
    deleteAllowed() {
        for (const run of this.selection) {
            if (run.completed) {
                return false;
            }
        }
        return true;
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = PvprojectCycleConfigHeadingLookup;
    }
    getAttachmentLinkColumn(attachment) {
        const label = `${attachment.attachmentType} - ${attachment.fileName}`;
        const attachmentLink = {
            text: label,
            address: "/module",
            clickAction: () => {
                this.downloadFile(attachment.id, attachment.fileName);
            }
        };
        return attachmentLink;
    }
    downloadFile(attachmentId, fileName) {
        this.settingsService.getAttachmentContentObservable(attachmentId)
            .subscribe({
            next: (response) => {
                FileUtils.openFile(fileName, response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage("Project cycle", error, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: NgbModal },
        { type: AppControllerService },
        { type: SettingsService },
        { type: SaShortDatePipe },
        { type: ChangeDetectorRef }
    ];
};
PvprojectCycleComponent = __decorate([
    Component({
        selector: "app-pv-project-cycle",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], PvprojectCycleComponent);
export { PvprojectCycleComponent };
